import { render, staticRenderFns } from "./FormMonotributo.vue?vue&type=template&id=28862b7f"
import script from "./FormMonotributo.vue?vue&type=script&lang=js"
export * from "./FormMonotributo.vue?vue&type=script&lang=js"
import style0 from "./FormMonotributo.vue?vue&type=style&index=0&id=28862b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports